import React, { createContext, useContext, useEffect, useState } from "react";
import { getSiteConfig, getNavigation, getPageContent } from "../api";
import defaultConfig from "../data/siteConfig";
import defaultNavigation from "../data/navigation";
import defaultContent from "../data/pageContent";

// Global site settings available everywhere via useSite().
// Starts with the bundled defaults (no flash), then refreshes from the api.
const defaults = {
  config: defaultConfig,
  navigation: defaultNavigation,
  content: defaultContent,
};
const SiteContext = createContext(defaults);

export function SiteProvider({ children }) {
  const [value, setValue] = useState(defaults);

  useEffect(() => {
    let alive = true;
    Promise.all([getSiteConfig(), getNavigation(), getPageContent()])
      .then(
        ([config, navigation, content]) =>
          alive && setValue({ config, navigation, content }),
      )
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
